const getSelectedFileIds = (selectedItems = []) => {
  return [
    ...new Set(
      selectedItems
        .map((item) => item?.documentFile?.documentFileId || item?.documentFileId)
        .filter(Boolean)
    ),
  ];
};

const getSelectedDocumentIds = (selectedItems = []) => {
  return [...new Set(selectedItems.map((item) => item?.documentId).filter(Boolean))];
};

export const resolveCartFileIdsToRemove = async ({
  selectedItems = [],
  showAllRevision = false,
  resolveDocumentFileIds,
}) => {
  const selectedFileIds = getSelectedFileIds(selectedItems);

  if (showAllRevision) {
    return selectedFileIds;
  }

  const selectedDocumentIds = getSelectedDocumentIds(selectedItems);

  if (!selectedDocumentIds.length || typeof resolveDocumentFileIds !== "function") {
    return selectedFileIds;
  }

  const resolvedFileIds = await resolveDocumentFileIds(selectedDocumentIds);

  if (!Array.isArray(resolvedFileIds) || !resolvedFileIds.length) {
    return selectedFileIds;
  }

  return [...new Set(resolvedFileIds.filter(Boolean))];
};
